import { chains } from 'src/assets/data/chains';

export const truncate = (value: string, head = 8, tail = 6) =>
  value && value.length > head + tail + 3
    ? `${value.slice(0, head)}...${value.slice(-tail)}`
    : value || '-';

export const explorerTxUrl = (chainId: number, txHash: string) => {
  if (!txHash) return '';
  const match = chains.find((c) => c.id === chainId);
  return match ? `${match.browser}${txHash}` : '';
};

export const chainSymbol = (chainId: number) => {
  const match = chains.find((c) => c.id === chainId);
  return match ? match.symbol : String(chainId);
};

export const statusColor = (status: string) => {
  switch (status) {
    case 'SUCCESS':
      return 'success';
    case 'FAILED':
      return 'error';
    case 'SKIPPED':
      return 'default';
    case 'PROCESSING':
      return 'info';
    default:
      return 'default';
  }
};
